import { View } from "./appHeader"

export const AppHeader = () => {
    return <View />
}